import React, {useState, useEffect} from 'react';
import {observer} from 'mobx-react';
import {Spinner, Table} from 'components';
import {Modal, ModalButtons} from 'components/modals';
import {FormattedMessage} from 'react-intl';
import {endpoints, types} from 'main/tools';
import {fetchModels} from 'shared/store';
import _ from 'lodash';
import {TimeOffRequest} from 'stores/time_off';
import {calendarDate} from 'shared/tools';

const columns = [
  {
    header: 'time_off.policy.edit.Employee',
    attribute: 'employee.name',
    width: 3
  },
  {
    header: 'time_off.policy.edit.Type',
    attribute: 'timeOffType.name',
    width: 3
  },
  {
    header: 'time_off.policy.edit.Start Date',
    render: model => calendarDate(model.startDate),
    width: 3
  },
  {
    header: 'time_off.policy.edit.End Date',
    render: model => calendarDate(model.endDate),
    width: 3
  }
];

const TypeRemovalConfirmationModal = observer(({isOpen, onCancel, onSave, removedTypes, policyId}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [pendingRequests, setPendingRequests] = useState([]);

  const removedTypeIds = _.map(removedTypes, 'id');

  useEffect(() => {
    if (isOpen && removedTypeIds.length > 0) {
      setIsLoading(true);

      const endpoint = endpoints.TIME_OFF.POLICY.PENDING_REQUESTS.with(policyId, removedTypeIds);

      fetchModels(endpoint, types.TIME_OFF.REQUEST).then(requests => {
        const sortedRequests = _.sortBy(
          _.map(requests, request => new TimeOffRequest(request)),
          'startDate'
        );
        setPendingRequests(sortedRequests);
        setIsLoading(false);
      });
    }
  }, [isOpen, removedTypeIds.join(','), policyId]);

  return (
    <Modal
      size='md'
      isOpen={isOpen}
      closeButton={false}
      title='time_off.policy.edit.confirmation.Remove Time Off Types'
    >
      <div className='mb2'>
        <div className='h4 b1'>
          <FormattedMessage id='time_off.policy.edit.The following time off types will be removed from this policy:'/>
        </div>
        <ul className='p2'>
          {removedTypes.map(type => (
            <li key={type.id} className='h4'>
              {type.name}
            </li>
          ))}
        </ul>
        <div className='mb2'>
          <FormattedMessage id='time_off.policy.edit.Employees will no longer be able to see their balance and request history for these time off types.'/>
        </div>
      </div>
      {isLoading ? (
        <div className='p3 center'>
          <Spinner/>
        </div>
      ) : (
        <React.Fragment>
          {pendingRequests.length > 0 && (
            <React.Fragment>
              <div className='h4 mb2'>
                <FormattedMessage id='time_off.policy.edit.The following pending requests will be deleted:'/>
              </div>
              <div className='mb2'>
                <Table
                  models={pendingRequests}
                  columns={columns}
                  showLinks={false}
                />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
      <ModalButtons
        onCancel={onCancel}
        onSave={onSave}
        saveEnabled={!isLoading}
        saveCaption='time_off.policy.edit.confirmation.Continue'
      />
    </Modal>
  );
});

export default TypeRemovalConfirmationModal;
